import React from "react";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import searchFileLottie from "../assets/lottie/Search_File.json";
import { SiteWide } from "./customComponents";
import Section from "./layouts/Section";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import HomeIcon from "@mui/icons-material/Home";

function NotFound() {
    const navigate = useNavigate();

    return (
        <SiteWide title="404 Page Not Found">
            <Section title="404 - Not Found">
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "space-between",
                    minHeight: "calc(100vh - 170px)",
                    padding: "20px 10px",
                    textAlign: "center",
                    boxSizing: "border-box"
                }}>
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        flexGrow: 1,
                        width: "100%"
                    }}>
                        <div style={{ width: 180, height: 180, marginBottom: 15 }}>
                            <Lottie
                                animationData={searchFileLottie}
                                loop={true}
                            />
                        </div>

                        <h3 style={{
                            color: "var(--text-main)",
                            fontFamily: "'Syne', sans-serif",
                            fontSize: "24px",
                            fontWeight: 800,
                            marginBottom: "10px",
                            marginTop: 0
                        }}>
                            Oops! Lost Link
                        </h3>

                        <p style={{
                            color: "var(--text-muted)",
                            fontFamily: "'DM Sans', sans-serif",
                            fontSize: "14px",
                            lineHeight: 1.5,
                            maxWidth: "280px",
                            marginBottom: "30px",
                            marginLeft: "auto",
                            marginRight: "auto"
                        }}>
                            The link you entered is not correct or the page has been moved. Let's get you back on track!
                        </p>

                        <div style={{
                            display: "flex",
                            gap: "12px",
                            justifyContent: "center",
                            width: "100%",
                            maxWidth: "280px"
                        }}>
                            <button
                                onClick={() => navigate(-1)}
                                className="btn-modern"
                                style={{
                                    flex: 1,
                                    padding: "12px",
                                    background: "var(--border-color)",
                                    border: "1px solid var(--border-color)",
                                    color: "#2563eb",
                                    fontSize: "13px",
                                    fontWeight: 700,
                                    borderRadius: "12px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "6px",
                                    cursor: "pointer",
                                    transition: "all 0.2s"
                                }}
                            >
                                <ChevronLeftIcon style={{ fontSize: 18 }} />
                                Go Back
                            </button>

                            <button
                                onClick={() => navigate("/")}
                                className="btn-modern btn-primary"
                                style={{
                                    flex: 1,
                                    padding: "12px",
                                    background: "linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)",
                                    border: "none",
                                    color: "#ffffff",
                                    fontSize: "13px",
                                    fontWeight: 700,
                                    borderRadius: "12px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "6px",
                                    cursor: "pointer",
                                    transition: "all 0.2s"
                                }}
                            >
                                <HomeIcon style={{ fontSize: 18 }} />
                                Home
                            </button>
                        </div>
                    </div>

                    {/* Subtle footer */}
                    <div style={{
                        marginTop: "30px",
                        fontSize: "11px",
                        color: "var(--text-muted)",
                        fontFamily: "'DM Sans', sans-serif",
                        display: "flex",
                        flexDirection: "column",
                        gap: "2px",
                        alignItems: "center",
                        opacity: 0.7
                    }}>
                        <span style={{ fontWeight: 400 }}>Tonya built it</span>
                        <a
                            href="mailto:hyiptonya@protonmail.com"
                            style={{
                                color: "#2563eb",
                                textDecoration: "none",
                                fontWeight: 600
                            }}
                        >
                            Entre em contato comigo
                        </a>
                    </div>
                </div>
            </Section>
        </SiteWide>
    );
}

export default NotFound;
